import { z } from "zod";

import { RoleGroupEnum } from "@classview/shared-types";

const emailObjectSchema = z.object({
  label: z.string(),
  value: z.string().email("Invalid email format"),
});

const addInvitationSchema = z.object({
  organisationId: z.string(),
  emails: z.array(emailObjectSchema).superRefine((emails, ctx) => {
    const invalidEmails = emails.filter(
      (obj) => !emailObjectSchema.safeParse(obj).success,
    );

    if (invalidEmails.length > 0) {
      const invalidEmailValues = invalidEmails.map((obj) => obj.value);
      ctx.addIssue({
        code: "custom",
        message: `The following emails are invalid: ${invalidEmailValues.join(
          ", ",
        )}`,
      });
    }
  }),
  roleGroup: z.nativeEnum(RoleGroupEnum, {
    errorMap: () => ({ message: "User role is required" }),
  }),
  organisationManagement: z.boolean(),
  userManagement: z.boolean(),
  jobPosting: z.boolean(),
  eventManagement: z.boolean(),
});
type AddInvitationFormData = z.infer<typeof addInvitationSchema>;

export { addInvitationSchema };
export type { AddInvitationFormData };
